export const PRESETS_TABS_LIST = [
  {
    label: 'Source presets',
    value: 'source',
    reportLabel: 'Source presets',
  },
  {
    label: 'Networks presets',
    value: 'network',
    reportLabel: 'Networks presets',
  },
];

export const CATEGORIES_FOR_PRESETS_TYPE = {
  source: 'source',
  network: 'network',
};

export const ALL_CATEGORY = {
  id: 'all',
  title: 'All',
  type: null,
  isSystemCategory: true,
  presets: [],
  priority: -1,
};

export const CATEGORIES_FOR_PRESETS_OPTIONS = {
  TITLE: 'Categories for Presets',
  SOURCE_NAME: 'acquisition',
  TABS_DATA: [...PRESETS_TABS_LIST],
};

/** Kind of account a category is offered to, as stored in `account_type`. */
export const TYPE_ACCOUNT_PRESET = {
  ALL: 0,
  ECOM: 1,
  AFFILIATE: 2,
} as const;
